import React from 'react';
import Exception from './components/Exception';

export class ErrorBoundary extends React.Component<React.PropsWithChildren> {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: any, errorInfo: any) { }
    render() {
        const message = 'Oops, something went wrong...?!';
        if (this.state.hasError) {
            return (
                <>
                    <Exception message={message} />
                </>
            );
        }
        return this.props.children;
    }
}